import 'C:\\Projects\\genkei\\zumeco\\static\\folder\\PdfDownloadStatusPanel.tsx.esbuild-plugin-windicss.css';
import { cx } from '@linaria/core';
import { createSharedState } from 'preact-shared-state-hook';
import { memo } from 'preact/compat';
import type { Doodle } from '../../server/src/models';
import { i18n } from '../shared/i18n';
import { downloadConcatenatedPdf, downloadDoodlePdf } from './downloadDoodlePdf';
interface QueueItem {
  readonly id: string;
  readonly filename: string;
  readonly doodleIds?: readonly string[];
}
let pdfDownloadPromise = Promise.resolve();
const [usePdfDownloadDoodleQueue, setPdfDownloadDoodleQueue] = createSharedState<readonly Readonly<{
  id: string;
  filename: string;
}>[]>([]);
const [usePdfDownloadedDoodleIds, setPdfDownloadedDoodleIds] = createSharedState(new Set<string>());
export const enqueuePdfDownloadDoodle = (downloading: Doodle | readonly Doodle[]) => {
  let item: QueueItem;
  if (Array.isArray(downloading)) {
    const doodles = downloading as readonly Doodle[];
    const doodleIds = doodles.map(({
      id
    }) => id);
    item = {
      id: doodleIds.join('+'),
      filename: `${doodles[0].filename.replace(/\..+?$/, '')}+.pdf`,
      doodleIds
    };
  } else {
    item = downloading as Doodle;
  }
  setPdfDownloadDoodleQueue(items => {
    if (items.some(({
      id
    }) => id === item.id)) {
      return items;
    }
    pdfDownloadPromise = pdfDownloadPromise.then(async () => {
      await (item.doodleIds ? downloadConcatenatedPdf(item.doodleIds, item.filename) : downloadDoodlePdf(item.id));
      setPdfDownloadDoodleQueue(items => items.filter(({
        id
      }) => id !== item.id));
      setPdfDownloadedDoodleIds(ids => new Set(ids).add(item.id));
    });
    return [...items, item];
  });
};
export { usePdfDownloadDoodleQueue, usePdfDownloadedDoodleIds };
export const PdfDownloadStatusPanel = memo(() => {
  const pdfDownloadDoodleIds = usePdfDownloadDoodleQueue();
  return pdfDownloadDoodleIds.length === 0 ? null : <div class="absolute bottom-2 right-2 box-shadow-primary bg-white">
      <div class="px-3 py-2 bg-primary">{i18n.downloadStatus.caption}</div>
      <ul class="px-3 py-2">
        {pdfDownloadDoodleIds.map((doodle, index) => <li key={doodle.id} class="py-1">
            <div class="flex items-center gap-2">
              <div class={cx('px-1 py-0.5 rounded text-sm', index === 0 ? 'bg-primary' : 'bg-gray-400 text-white')}>
                {index === 0 ? i18n.downloadStatus.inProgress : i18n.downloadStatus.pending}
              </div>
              <div>{doodle.filename}</div>
            </div>
          </li>)}
      </ul>
    </div>;
});